__turbopack_context__.v({
  "buttonCloseIconWhite": "GallerySliderMobile-module-scss-module__f8SKWW__buttonCloseIconWhite",
  "content": "GallerySliderMobile-module-scss-module__f8SKWW__content",
  "crumbs": "GallerySliderMobile-module-scss-module__f8SKWW__crumbs",
  "img": "GallerySliderMobile-module-scss-module__f8SKWW__img",
  "loader": "GallerySliderMobile-module-scss-module__f8SKWW__loader",
  "nav": "GallerySliderMobile-module-scss-module__f8SKWW__nav",
  "nav__counter": "GallerySliderMobile-module-scss-module__f8SKWW__nav__counter",
  "nav__wrapper": "GallerySliderMobile-module-scss-module__f8SKWW__nav__wrapper",
  "selector": "GallerySliderMobile-module-scss-module__f8SKWW__selector",
  "selector__active": "GallerySliderMobile-module-scss-module__f8SKWW__selector__active",
  "selector__arrow": "GallerySliderMobile-module-scss-module__f8SKWW__selector__arrow",
  "selector__arrow_down": "GallerySliderMobile-module-scss-module__f8SKWW__selector__arrow_down",
  "selector__content": "GallerySliderMobile-module-scss-module__f8SKWW__selector__content",
  "selector__line": "GallerySliderMobile-module-scss-module__f8SKWW__selector__line",
  "selector__list": "GallerySliderMobile-module-scss-module__f8SKWW__selector__list",
  "selector__top": "GallerySliderMobile-module-scss-module__f8SKWW__selector__top",
  "selector__top__title": "GallerySliderMobile-module-scss-module__f8SKWW__selector__top__title",
  "showBtn": "GallerySliderMobile-module-scss-module__f8SKWW__showBtn",
  "showBtn__active": "GallerySliderMobile-module-scss-module__f8SKWW__showBtn__active",
  "showBtn__list": "GallerySliderMobile-module-scss-module__f8SKWW__showBtn__list",
  "showBtn__switch": "GallerySliderMobile-module-scss-module__f8SKWW__showBtn__switch",
  "swiper": "GallerySliderMobile-module-scss-module__f8SKWW__swiper",
  "swiperSlide": "GallerySliderMobile-module-scss-module__f8SKWW__swiperSlide",
});
